import { useParams } from 'react-router'
import PlayerDetails from './components/PlayerDetails'
import PlayerHeader from './components/PlayerHeader'
import classes from './Players.module.css'
import { usePlayerDetails } from './api'
import { Page } from '../widgets/Page'
import { useCompetitionId } from '../common/hooks'

export default function Player() {
  const { competitionId, playerId } = useParams()
  const competition_id = useCompetitionId()
  const { data: player } = usePlayerDetails({
    competition_id: Number(competitionId),
    player_id: Number(playerId),
  })

  return (
    <Page
      path={'/competitions/players'}
      context={{
        subject_type: 'user',
        subject: Number(player.user_id || 1),
        competition_id: competition_id,
      }}
    >
      <div className={classes.player_container}>
        <PlayerHeader player={player} competitionId={competitionId} />
        <PlayerDetails player={player} />
      </div>
    </Page>
  )
}
